import ConventionMeetingType from "./ConventionMeetingType"
import { VideoPlatform } from "app-constants/constants"
import ResourceModel from "models/convention-api/ResourceModel"
import AdminUser from "models/convention-api/v1/AdminUser"
import Institution from "models/convention-api/v1/Institution"
import moment from "moment-timezone"

export default class ConventionMeetingAvailability extends ResourceModel {
  protected static basePath =
    "/v1/convention_providers/:provider_id/convention_meeting_availabilities"
  protected static rels = {
    meetingType: () => ({
      type: ConventionMeetingType,
      from: "convention_meeting_type_id",
      filterOn: "id",
    }),
    adminUser: () => ({
      type: AdminUser,
      from: "admin_user_id",
      filterOn: "id",
    }),
    institution: () => ({
      type: Institution,
      from: "institution_id",
      filterOn: "id",
    }),
  }

  integrated_meeting_url!: string
  start_at!: moment.Moment
  end_at!: moment.Moment
  convention_meeting_type_id!: string
  available_slots_count!: number
  available_times!: string[][]
  admin_user_id!: string
  whereby_room_created!: boolean
  video_platform!: VideoPlatform

  adminUser?: AdminUser
  institution?: Institution
  meetingType?: ConventionMeetingType
}
